<div class="card">
	<p-table [value]="venueSvc.ooIntegratorPrice" styleClass="p-datatable-responsive-demo">
		<ng-template pTemplate="caption">
			<div class="d-flex">
				<div class="ms-auto">
					<p-button pRipple styleClass="p-button-raised m-2" (click)="newIntegratorPrice()">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Name</th>
				<th>Item Price</th>
				<th>Modifier Price</th>
				<th>Available Times</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-rec>
			<tr>
				<td>
					{{ rec.name }}
				</td>
				<td>
					<p-dropdown
						[options]="venueSvc.priceNumbers"
						optionLabel="label"
						optionValue="value"
						name="priceList"
						[disabled]="true"
						[(ngModel)]="rec.itemPrice"
						[style]="{ width: '100%' }"
						appendTo="body"
					></p-dropdown>
				</td>
				<td>
					<p-dropdown
						[options]="venueSvc.priceNumbers"
						optionLabel="label"
						optionValue="value"
						name="priceList"
						[disabled]="true"
						[(ngModel)]="rec.modifierPrice"
						[style]="{ width: '100%' }"
						appendTo="body"
					></p-dropdown>
				</td>
				<td>
					<span *ngIf="rec.timeRangeKey">
						<p-dropdown
							[options]="venueSvc.timeRanges"
							optionLabel="name"
							optionValue="key"
							name="modifierPrice"
							[disabled]="true"
							[autoDisplayFirst]="false"
							[(ngModel)]="rec.timeRangeKey"
							[style]="{ width: '100%' }"
							appendTo="body"
						></p-dropdown>
					</span>
				</td>
				<th>
					<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="integratorPriceSelected = rec">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'pencil']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="integratorPriceDelete(rec)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'times']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</th>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog
	header="Integrator Price"
	[(visible)]="integratorPriceSelected"
	*ngIf="integratorPriceSelected"
	[breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
	[style]="{ width: '50vw' }"
>
	<div class="d-flex flex-column">
		<div class="mt-4">
			<span class="p-float-label">
				<input pInputText type="text" name="priceName" [(ngModel)]="integratorPriceSelected.name" class="w-100" />
				<label for="priceName">3rd Party Name</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<p-dropdown
					[options]="venueSvc.priceNumbers"
					optionLabel="label"
					optionValue="value"
					name="itemPrice"
					[autoDisplayFirst]="false"
					[(ngModel)]="integratorPriceSelected.itemPrice"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
				<label for="itemPrice">Item Price</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<p-dropdown
					[options]="venueSvc.priceNumbers"
					optionLabel="label"
					optionValue="value"
					name="modifierPrice"
					[autoDisplayFirst]="false"
					[(ngModel)]="integratorPriceSelected.modifierPrice"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
				<label for="modifierPrice">Modifier Price</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<p-dropdown
					[options]="venueSvc.timeRanges"
					optionLabel="name"
					optionValue="key"
					name="modifierPrice"
					[autoDisplayFirst]="false"
					[(ngModel)]="integratorPriceSelected.timeRangeKey"
					[style]="{ width: '100%' }"
					appendTo="body"
				></p-dropdown>
				<label for="modifierPrice">Available</label>
			</span>
		</div>
	</div>
	<p-footer>
		<div class="d-flex justify-content-end">
			<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="integratorPriceSelected = undefined">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'times']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<p-button
				[disabled]="!integratorPriceSelected.itemPrice || !integratorPriceSelected.modifierPrice || !integratorPriceSelected.name"
				pRipple
				styleClass="p-button-raised m-2 ms-auto"
				(click)="venueSvc.integratorPricePost(integratorPriceSelected); integratorPriceSelected = undefined"
			>
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</p-footer>
</p-dialog>
